import { jsxs, jsx } from 'react/jsx-runtime';
function SpinTheWheelSvg({
  headline = ''
}) {
  return /*#__PURE__*/jsxs("svg", {
    viewBox: "0 0 200 200",
    children: [/*#__PURE__*/jsx("rect", {
      width: "100%",
      height: "100%",
      fill: "#FFD200"
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        id: "text-path",
        d: " M100,20 A80,80 0 0,1 180,100 A80,80 0 0,1 100,180 A80,80 0 0,1 20,100 A80,80 0 0,1 100,20 "
      })
    }), /*#__PURE__*/jsx("circle", {
      cx: "100",
      cy: "100",
      r: "100",
      fill: "white"
    }), /*#__PURE__*/jsx("text", {
      fontSize: "18px",
      children: /*#__PURE__*/jsx("textPath", {
        href: "#text-path",
        children: headline
      })
    })]
  });
}
export { SpinTheWheelSvg };
//# sourceMappingURL=SpinTheWheelSvg.js.map
